import { useQuery } from 'react-query';
import { DocketCaseDocument } from '../../models/CompanyDockets';
import { fetchCaseDocuments } from '../../services/dockets/dockets.service';
import { queryKeys } from '../queryKeyFactory';

export interface CaseDocumentsQueryFilters {
  itemFiledFromDate?: string;
  itemFiledToDate?: string;
  keyword?: string;
}

export interface UseFetchCaseDocumentsQuery {
  isLoading: boolean;
  isError: boolean;
  data?: DocketCaseDocument[];
  refetch: () => void;
  totalPages: number;
  totalDocuments: number;
}

export interface UseFetchCaseDocumentQueryResult {
  result: DocketCaseDocument[];
  totalPages: number;
  totalDocuments: number;
}

export default (
  docketCaseId: number,
  page: number,
  pageSize: number,
  keyFilings: boolean,
  filters: CaseDocumentsQueryFilters
): UseFetchCaseDocumentsQuery => {
  const query = useQuery<UseFetchCaseDocumentQueryResult, Error>(
    queryKeys.dockets.fetchDocuments.query(docketCaseId, page, pageSize, filters, keyFilings),
    async () => {
      const response = await fetchCaseDocuments(
        docketCaseId,
        {
          page: page - 1,
          take: pageSize,
          keyFilings,
        },
        filters
      );
      return {
        result: response.docketItemList.map((item) => ({
          docketItemCaseId: item.docketItemCaseId,
          docketItemId: item.docketItemId,
          docketNumber: item.docketItemNumber,
          description: item.docketItemText,
          filedDate: item.docketItemFiledDate,
          isAttachment: false,
          hasAttachments: Number(item.docketItemNumAttachments) > 0,
          link: item.docketItemPermalink,
          fileAvailable: !!item.docketItemFileAvailable,
          canAccess: item.canAccess,
          docketItemCost: item?.docketItemCost,
        })),
        totalPages: response.page.totalPages,
        totalDocuments: response.page.totalElements,
      };
    },
    {
      enabled: !Number.isNaN(Number(docketCaseId)),
    }
  );
  return {
    isLoading: query.isLoading,
    isError: query.isError,
    data: query.data?.result,
    refetch: query.refetch,
    totalPages: query.data?.totalPages || 0,
    totalDocuments: query.data?.totalDocuments || 0,
  };
};
